export const accountingOnboardingStatuses = {
  INACTIVE: "inactive",
  ACTIVATED: "activated",
  COMPLETED: "completed",
};

export function getAccountingOnboardingStatusEntity(response) {
  return response?.data?.entity || response?.data?.data || response?.data || {};
}

export function isAccountingOnboardingActivated(statusEntity) {
  const normalizedStatus = statusEntity?.status?.toString().trim().toLowerCase();

  return [accountingOnboardingStatuses.ACTIVATED, accountingOnboardingStatuses.COMPLETED].includes(normalizedStatus);
}
